export default __webpack_public_path__ + "static/media/tutorial-easy.4b434f27.gif";